// Import React helpers.
import React, {
    useEffect,
    useState,
} from "react";


// Import the page stylesheet.
import "global/components/BackToTopButton.css";



// Export the reusable back-to-top button.
export const BackToTopButton = () => {

    
    // Store whether the button should currently be visible.
    const [buttonIsVisible, setButtonIsVisible] = useState(false);



    // Watch the current page scroll position.
    useEffect(() => {

        // Handle changes to the browser scroll position.
        const handleScroll = () => {

            // Show the button after the user has scrolled down the page.
            setButtonIsVisible(window.scrollY > 300);

        };

        // Run once immediately so the initial state is correct.
        handleScroll();

        // Listen for page scrolling.
        window.addEventListener(
            "scroll",
            handleScroll,
            {
                passive: true,
            }
        );

        // Remove the event listener when the component unmounts.
        return () => {

            // Remove the scroll listener.
            window.removeEventListener(
                "scroll",
                handleScroll
            );

        };

    }, []);



    // Scroll back to the top of the page.
    const handleBackToTop = () => {

        // Smoothly scroll the browser back to the top.
        window.scrollTo({

            // Scroll to the top edge of the document.
            top: 0,

            // Animate the scroll movement.
            behavior: "smooth",

        });

    };



    // Do not render the button until it is needed.
    if (!buttonIsVisible) {

        // Return nothing while the page is near the top.
        return null;

    }



    // Render the floating button.
    return (

        // Render the back-to-top control.
        <button
            className="back-to-top"
            type="button"
            onClick={handleBackToTop}
            aria-label="Back to top"
            title="Back to top"
        >

            {/* Render the upward arrow icon. */}
            <svg
                className="back-to-top__icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >

                {/* Draw the upward arrow. */}
                <path d="M6 14L12 8L18 14" />

            </svg>

        </button>

    );

};